import type { Action, SagaCallbacks } from '../types';
import * as actionTypes from './actionTypes';

export const requestLoadWorkoutEvents = ({
  params,
  userId,
  fetchAll,
}: {
  params: any;
  userId?: number;
  fetchAll?: boolean,
}): Action => ({
  type: actionTypes.REQUEST_LOAD_WORKOUT_EVENTS,
  params,
  userId,
  fetchAll,
});

export const requestCreateWorkoutEvents = ({
  isNow,
  userId,
  payload,
  callbacks,
}: {
  isNow?: boolean;
  userId: number;
  payload: any;
  callbacks?: SagaCallbacks;
}): Action => ({
  type: actionTypes.REQUEST_CREATE_WORKOUT_EVENT,
  payload,
  userId,
  isNow,
  callbacks,
});

export const requestUpdateWorkoutEvent = ({
  id,
  userId,
  payload,
  callbacks,
}: {
  id: number
  userId: number
  payload: any
  callbacks: SagaCallbacks
}): Action => ({
  type: actionTypes.REQUEST_UPDATE_WORKOUT_EVENT,
  id,
  userId,
  payload,
  callbacks,
});

export const requestLoadFullWorkoutEvent = ({ id }: { id: number }): Action => ({
  type: actionTypes.REQUEST_LOAD_FULL_WORKOUT_EVENT,
  id,
});

export const requestCreateWorkoutEventResult = ({
  items,
  eventId,
  workoutExerciseId,
}: {
  items: any;
  eventId: number;
  workoutExerciseId: number;
}): Action => ({
  type: actionTypes.REQUEST_CREATE_WORKOUT_EVENT_RESULT,
  items,
  eventId,
  workoutExerciseId,
});

export const requestRemoveAllEventResults = (
  eventId: number,
): Action => ({
  type: actionTypes.REQUEST_REMOVE_ALL_EVENT_RESULTS,
  eventId,
});

export const requestFinishEvent = (
  eventId: number,
  callbacks?: SagaCallbacks,
): Action => ({
  type: actionTypes.REQUEST_FINISH_EVENT,
  eventId,
  callbacks,
});
